export const SHMNEXT_API_URL = 'https://api.shmnext.com' //@TODO change this to process.env using webpack
export const API_BASE_URL =  'https://compassapi.shmnext.com'
